import React, { createContext, useContext, useState } from "react";

type EditModeContextType = {
  isEditing: boolean;
  setEditing: (value: boolean) => void;
};

const EditModeContext = createContext<EditModeContextType | null>(null);

export const EditModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isEditing, setIsEditing] = useState(false);

  const setEditing = (value: boolean) => {
    setIsEditing(value);
  };

  return (
    <EditModeContext.Provider value={{ isEditing, setEditing }} //NOSONAR
    >
      {children}
    </EditModeContext.Provider>
  );
};

export const useEditMode = () => {
  const ctx = useContext(EditModeContext);
  if (!ctx) throw new Error("useEditMode must be used inside EditModeProvider");
  return ctx;
};